export default {
    gtm_id: "GTM-TLH67WS"
};
